import { defineStore } from "pinia";
import Services from '@/services/ResidenceDataServices'
import { mapResidence } from '@/helpers/mapFuncs'

export const useResidenceDataStore = defineStore("residenceData", {

state:()=>({
    residence: {},
    residences: [],
}),
getters : {
    getResidence() {
        return mapResidence(this.residence)
    },
    getResidences() {
        return this.residences.map(mapResidence)
    }
},
actions : {
    /** Start Sets */
    setResidence(residence) {
        this.residence = residence
    },
    setResidences(residences) {
        this.residences = residences
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setResidence(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setResidence(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setResidences(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.residences.push(mapResidence(response.data))
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.residences[this.residences.findIndex((x)=>x.id == id)] = response.data
            return mapResidence(response.data.data);
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.residences = this.residences.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});